import './Slider.less';
import React, {useEffect, useRef} from 'react';
import initSlider from "../../../libs/slider/slider";

export default function Slider(
    {
        children,

        viewLargeOffset = 900,
        viewMediumOffset = 500,

        pageSize = 1,
        pageSizeLarge = 1,
        pageSizeMedium = 1,
        pageSizeSmall = 1,

        previewLeft = 0,
        previewLeftLarge,
        previewLeftMedium,
        previewLeftSmall,

        previewRight = 0,
        previewRightLarge,
        previewRightMedium,
        previewRightSmall,

        displayArrows = true,
        displayArrowsLarge,
        displayArrowsMedium,
        displayArrowsSmall,

        displayNavigator = false,
        displayNavigatorLarge,
        displayNavigatorMedium,
        displayNavigatorSmall,

        displayThumbnails = false,
        displayThumbnailsLarge = false,
        displayThumbnailsMedium = false,
        displayThumbnailsSmall = false,

        slideTime = 1000,
        slideTiming = 'ease-out',
        swipeTiming = 'ease-out',
        maxSwipeAngle = 60,

        autorunDelay,
        autorunPauseOnHover,

        repeatAtFirst = false,
        repeatAtLast = false,

        itemAspectRatio = 'adjust-by-typed-items',
    }
) {

    const containerRef = useRef(null);

    useEffect(() => {
        if (containerRef.current !== null) {
            initSlider(containerRef.current);
        }
    }, []);

    return <div
        className="slider"
        ref={containerRef}

        data-view-large-offset={viewLargeOffset}
        data-view-medium-offset={viewMediumOffset}

        data-page-size={pageSize}
        data-page-size-large={pageSizeLarge}
        data-page-size-medium={pageSizeMedium}
        data-page-size-small={pageSizeSmall}

        data-preview-left={previewLeft}
        data-preview-left-large={previewLeftLarge}
        data-preview-left-medium={previewLeftMedium}
        data-preview-left-small={previewLeftSmall}

        data-preview-right={previewRight}
        data-preview-right-large={previewRightLarge}
        data-preview-right-medium={previewRightMedium}
        data-preview-right-small={previewRightSmall}
        
        data-display-arrows={displayArrows}
        data-display-arrows-large={displayArrowsLarge}
        data-display-arrows-medium={displayArrowsMedium}
        data-display-arrows-small={displayArrowsSmall}
        
        data-display-navigator={displayNavigator}
        data-display-navigator-large={displayNavigatorLarge}
        data-display-navigator-medium={displayNavigatorMedium}
        data-display-navigator-small={displayNavigatorSmall}
        
        data-display-thumbnails={displayThumbnails}
        data-display-thumbnails-large={displayThumbnailsLarge}
        data-display-thumbnails-medium={displayThumbnailsMedium}
        data-display-thumbnails-small={displayThumbnailsSmall}
        
        data-slide-time={slideTime}
        data-slide-timing={slideTiming}
        data-swipe-timing={swipeTiming}
        data-max-swipe-angle={maxSwipeAngle}
        data-autorun-delay={autorunDelay}
        data-autorun-pause-on-hover={autorunPauseOnHover}

        data-repeat-at-first={repeatAtFirst}
        data-repeat-at-last={repeatAtLast}

        data-item-aspect-ratio={itemAspectRatio}
    >
        {children}
    </div>;
}
